// extracted by mini-css-extract-plugin
export default {"container":"AI-z","disabled":"BI-z","bgBlack":"CI-z","content":"DI-z","countdown":"EI-z","topCaption":"FI-z","topHeading":"GI-z","heading":"HI-z","copy":"II-z"};